import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';

const EMAIL_URL = '/api/email';

export const emailApiSlice = createApi({
  reducerPath: 'emailApi',
  baseQuery: fetchBaseQuery({ baseUrl: process.env.REACT_APP_FETCH_URL, credentials: 'include' }),
  endpoints: (builder) => ({
    sendCode: builder.mutation({
      query: (email) => ({
        url: `${EMAIL_URL}/send-code`,
        method: 'POST',
        body: email,
      }),
    }),
    verifyCode: builder.mutation({
      query: (data) => ({
        url: `${EMAIL_URL}/verify-code`,
        method: 'POST',
        body: data,
      }),
    }),
  }),
});

export const { useSendCodeMutation, useVerifyCodeMutation } = emailApiSlice;